<template>
  <div ref="list" class="help-center-table-of-contents__list">
    <div
      v-for="component in extendedComponents"
      ref="items"
      :key="component.id"
      :class="component.itemClass"
      class="help-center-table-of-contents__item"
    >
      <a
        :href="component.href"
        :class="component.linkClass"
        class="help-center-table-of-contents__link"
      >
        {{ component.title }}
      </a>
    </div>
  </div>
</template>

<script setup>
import { ref, toRef, computed } from 'vue'
import useAutoScroller from 'help-center/composables/useAutoScroller'

const props = defineProps({
  components: {
    type: Array,
    required: true
  },
  rootFragment: String
})

const list = ref(null)
const items = ref([])
const extendedComponents = computed(() => {
  return props.components.map((component) => {
    const isCurrent = props.rootFragment === component.fragment

    return {
      ...component,
      href: '#' + component.fragment,
      itemClass: isCurrent ? 'help-center-table-of-contents__item--active' : null,
      linkClass: isCurrent ? 'help-center-table-of-contents__link--active' : null
    }
  })
})

useAutoScroller(list, items, toRef(props, 'rootFragment'))
</script>

<style lang="scss">
@import 'help-center/mixins';

.help-center-table-of-contents {
  &__list {
    @include help-center-thin-scrollbar;
    overflow-x: hidden;
  }

  &__item {
    padding: 4px 8px 4px 16px;
    border-left: 1px solid var(--help-center-border);

    @include help-center-animated-outline(active, $at: left, $offset: 1px);
  }

  &__link {
    @include help-center-muted-link($offset: 2px);
    @include help-center-font(14);
    display: inline-block;

    &--active {
      color: var(--help-center-accent);
      font-weight: var(--help-center-bold);
    }
  }
}
</style>
